import { compact } from 'lodash-es';
import { AccountingStatusFilter } from "../../business-logic/qboStatusFilterLogic";
export let HeaderItemId = /*#__PURE__*/function (HeaderItemId) {
  HeaderItemId["Status"] = "status";
  HeaderItemId["Amount"] = "amount";
  HeaderItemId["PayoutId"] = "payoutId";
  HeaderItemId["InvoiceNo"] = "invoiceNo";
  HeaderItemId["SyncStatus"] = "syncStatus";
  return HeaderItemId;
}({});
const sortByDepositDate = (a, b) => b.createdAt() - a.createdAt();
const sortById = (a, b) => a.id() < b.id() ? -1 : 1;
const sortByAmount = (a, b) => b.amount().sub(a.amount()).toNumber();
const sortByFormattedNumber = (a, b) => a.formattedNumber() < b.formattedNumber() ? -1 : 1;
const sortFunctions = {
  [HeaderItemId.InvoiceNo]: isAscending => (a, b) => {
    const retval = sortByDepositDate(a, b) || sortById(a, b);
    return isAscending ? -retval : retval;
  },
  [HeaderItemId.Status]: isAscending => (a, b) => {
    // Status is always 'paid' so there's nothing to sort in this column.
    const retval = sortById(a, b);
    return isAscending ? -retval : retval;
  },
  [HeaderItemId.Amount]: isAscending => (a, b) => {
    const retval = sortByAmount(a, b) || sortById(a, b);
    return isAscending ? -retval : retval;
  },
  [HeaderItemId.PayoutId]: isAscending => (a, b) => {
    const retval = sortByFormattedNumber(a, b);
    return isAscending ? -retval : retval;
  },
  [HeaderItemId.SyncStatus]: () => () => 0
};
function applySearch(payouts, search) {
  const normalizedSearch = search ? search.trim().toLowerCase() : search;
  return payouts.filter(payout => {
    const searchWords = [payout.formattedNumber()];
    payout.invoices().forEach(invoice => {
      searchWords.push(invoice.formattedNumber);
      const clientName = invoice.customer;
      clientName && searchWords.push(clientName);
    });
    return searchWords.join(' ').toLowerCase().includes(normalizedSearch);
  });
}
function applyQboStatusFilter(payouts, qboStatusFilter) {
  switch (qboStatusFilter) {
    case AccountingStatusFilter.All:
      return payouts;
    case AccountingStatusFilter.Synced:
      return payouts.filter(p => p.isQboSynced());
    case AccountingStatusFilter.NotSynced:
      return payouts.filter(p => !p.isQboSynced());
  }
}
function applyXeroStatusFilter(payouts, xeroStatusFilter) {
  switch (xeroStatusFilter) {
    case AccountingStatusFilter.All:
      return payouts;
    case AccountingStatusFilter.Synced:
      return payouts.filter(p => p.isXeroSynced());
    case AccountingStatusFilter.NotSynced:
      return payouts.filter(p => !p.isXeroSynced());
  }
}
export function applyFilters(_ref) {
  let {
    payouts,
    qboStatusFilter,
    xeroStatusFilter,
    search
  } = _ref;
  let filtered = payouts;
  filtered = applySearch(filtered, search);
  if (qboStatusFilter != null) {
    filtered = applyQboStatusFilter(filtered, qboStatusFilter);
  }
  if (xeroStatusFilter != null) {
    filtered = applyXeroStatusFilter(filtered, xeroStatusFilter);
  }
  return filtered;
}
export function applySort(payouts, sort, headerItemId) {
  if (sort && headerItemId) {
    payouts.sort(sortFunctions[headerItemId](sort.sort === 'asc'));
  }
  return payouts;
}
export function getAccountingStatusFilterOptions(accountingStatusFilterCounters) {
  const syncedCounter = accountingStatusFilterCounters.synced || 0;
  const notSyncedCounter = accountingStatusFilterCounters.notSynced || 0;
  const options = [{
    value: AccountingStatusFilter.All,
    label: 'All',
    counter: syncedCounter + notSyncedCounter
  }, {
    value: AccountingStatusFilter.Synced,
    label: 'Synced',
    counter: syncedCounter
  }, {
    value: AccountingStatusFilter.NotSynced,
    label: 'Not synced',
    counter: notSyncedCounter
  }];
  return options.filter(option => option.value === AccountingStatusFilter.All || option.counter > 0);
}
export function getAccountingStatusFilterOptionsFromPayouts(payouts, checkSynced) {
  const options = [{
    value: AccountingStatusFilter.All,
    label: 'All',
    counter: payouts.length
  }, {
    value: AccountingStatusFilter.Synced,
    label: 'Synced',
    counter: 0
  }, {
    value: AccountingStatusFilter.NotSynced,
    label: 'Not synced',
    counter: 0
  }];
  payouts.forEach(payout => {
    checkSynced(payout) && options[1].counter++;
    !checkSynced(payout) && options[2].counter++;
  });
  return options.filter(opt => opt.counter > 0);
}
export function getTableConfig(_ref2) {
  let {
    showQboIntegration,
    showXeroIntegration
  } = _ref2;
  const data = compact([{
    columnDef: {
      width: showQboIntegration || showXeroIntegration ? 170 : 108,
      sortable: true,
      hAlign: 'start'
    },
    headerItem: {
      id: HeaderItemId.PayoutId,
      value: 'Payout ID'
    }
  }, {
    columnDef: {
      width: 108,
      sortable: true,
      hAlign: 'end'
    },
    headerItem: {
      id: HeaderItemId.InvoiceNo,
      value: 'Deposit date'
    }
  }, {
    columnDef: {
      width: 30
    },
    headerItem: {
      id: null,
      value: null
    }
  }, {
    columnDef: {
      width: 100,
      sortable: true,
      hAlign: 'end'
    },
    headerItem: {
      id: HeaderItemId.Status,
      value: 'Status'
    }
  }, {
    columnDef: {
      width: [100, 200],
      sortable: true,
      hAlign: 'end'
    },
    headerItem: {
      id: HeaderItemId.Amount,
      value: 'Amount'
    }
  }]);
  return {
    columnDefs: data.map(d => d.columnDef),
    headerItems: data.map(d => d.headerItem)
  };
}
export const mapHeaderIdToBackendField = headerId => {
  switch (headerId) {
    case HeaderItemId.PayoutId:
      return 'formatted_number';
    case HeaderItemId.InvoiceNo:
      return 'deposit_date';
    case HeaderItemId.Status:
      return 'status';
    case HeaderItemId.Amount:
      return 'amount';
    default:
      return 'formatted_number';
  }
};